export default __webpack_public_path__ + "images/e6b69625fa3dd52cd1a81006c48aa3c7-success.svg";